<nb-card class="placement-dialog">
  <nb-card-header>
    <h4>{{ 'pages.tutors.placements.lms.editTitle' | translate }}</h4>
    <p class="placement-dialog__hint">
      {{ course.fullname }} <span class="muted">({{ course.shortname }})</span>
    </p>
  </nb-card-header>

  <nb-card-body>
    <form [formGroup]="form" class="placement-dialog__form">
      <div class="form-row">
        <label>{{ 'pages.tutors.placements.lms.field.tutor' | translate }}</label>
        <nb-select
          formControlName="bot_id"
          [placeholder]="'pages.tutors.placements.lms.field.tutorPlaceholder' | translate"
          fullWidth
        >
          <nb-select-label>
            <ng-container *ngIf="tutorById(form.value.bot_id) as selectedTutor">
              <span
                class="placement-tutor-label"
                [title]="tutorFullLabel(selectedTutor)"
                [nbTooltip]="tutorFullLabel(selectedTutor)"
                nbTooltipPlacement="top"
              >
                <span class="placement-tutor-label__name">{{ selectedTutor.name }}</span>
                <span
                  *ngIf="tutorVisualName(selectedTutor)"
                  class="placement-tutor-label__visual"
                >
                  {{ tutorVisualName(selectedTutor) }}
                </span>
              </span>
            </ng-container>
          </nb-select-label>
          <nb-option *ngFor="let t of tutors" [value]="t.id">
            <span
              class="placement-tutor-option"
              [title]="tutorFullLabel(t)"
              [nbTooltip]="tutorFullLabel(t)"
              nbTooltipPlacement="top"
            >
              <span class="placement-tutor-option__name">{{ t.name }}</span>
              <span *ngIf="tutorVisualName(t)" class="placement-tutor-option__visual">
                {{ tutorVisualName(t) }}
              </span>
            </span>
          </nb-option>
        </nb-select>
      </div>

      <div class="form-row">
        <label>{{ 'pages.tutors.placements.lms.field.visible' | translate }}</label>
        <div>
          <nb-toggle formControlName="visible">
            {{
              form.value.visible
                ? ('pages.tutors.placements.lms.visible' | translate)
                : ('pages.tutors.placements.lms.hidden' | translate)
            }}
          </nb-toggle>
        </div>
      </div>

      <div class="form-row">
        <label>{{ 'pages.tutors.placements.lms.field.primaryColor' | translate }}</label>
        <input
          type="color"
          formControlName="primary_color"
          class="placement-dialog__color"
        />
      </div>
    </form>
  </nb-card-body>

  <nb-card-footer class="placement-dialog__footer">
    <button nbButton ghost status="basic" size="small" (click)="cancel()" [disabled]="saving">
      {{ 'buttons.cancel' | translate }}
    </button>
    <button
      nbButton
      status="primary"
      size="small"
      (click)="save()"
      [disabled]="saving || form.invalid"
    >
      <nb-icon *ngIf="saving" icon="loader-outline" class="spin"></nb-icon>
      {{ 'buttons.save' | translate }}
    </button>
  </nb-card-footer>
</nb-card>
